import { AppRuntimeLogsDataFallback } from '@/routes/app/tabs/runtime-logs/runtime-logs-data/runtime-logs-data-fallback'

export const AppRuntimeLogsTabFallback = () => {
  return <AppRuntimeLogsDataFallback />
}
